// Libs
import React from 'react';
import {
  Card as MuiCard,
  CardMedia,
  CardContent,
  Box,
  Typography,
} from '@mui/material';

// Components
import Image from '../../Image';

// Hooks

import useUnavailableForOrderProduct from '../../../hooks/useUnavailableForOrderProduct';
import useUI from '../../../hooks/useUI';

// Styles
import { useStyles } from './ValidateCardStyles';

const IMAGE_HEIGHT_DESKTOP = 275;
const IMAGE_HEIGHT_TABLET = 243;
const IMAGE_HEIGHT_MOBILE = 136;

const ValidateCard = ({ product, cardContent, imageContainer }) => {
  const { isMobileMode } = useUI();
  const {
    image_link: image,
    product_id: stockNumber,
    product_description: description,
  } = product || {};

  const { isUnavailableForOrder, unavailableWatermark } =
    useUnavailableForOrderProduct(product, false, false, true);
  const { classes } = useStyles({ isUnavailableForOrder, isMobileMode });
  return (
    <MuiCard disabled={!image} className={classes.root}>
      <Box className={classes.actionArea}>
        {unavailableWatermark}
        <Image
          alt="productImage"
          src={image}
          imageContainer={
            imageContainer || {
              desktop: [IMAGE_HEIGHT_DESKTOP],
              tablet: [IMAGE_HEIGHT_TABLET],
              mobile: [IMAGE_HEIGHT_MOBILE],
            }
          }>
          <CardMedia
            id="image-button"
            className={classes.img}
            component="img"
            image={image}
            alt="productImage"
          />
        </Image>
      </Box>
      {!cardContent ? (
        <CardContent className={classes.content}>
          <div className={classes.stackedContent}>
            <Box
              alignItems="start"
              display="flex"
              justifyContent="space-between"
              width="100%"
              gap={1}>
              <Typography className={classes.description}>
                {description}
              </Typography>
            </Box>
            <div className={classes.details}>
              <div
                className={classes.detailsItem}
                data-testid="product-card-stock-number">
                <span className={classes.detailsBold}>Stock Number:</span>
                <span className={classes.detailsNormal}>{stockNumber}</span>
              </div>
            </div>
          </div>
        </CardContent>
      ) : (
        cardContent
      )}
    </MuiCard>
  );
};

export default ValidateCard;
